import React from "react";
import PropTypes from "prop-types";
import "./search-bar.scss";

const SearchBar = ({ placeholder, searchAction, typeAction, ...props }) => (
  <div className="search-bar">
    <input
      className="py-0.5 px-2 text-xs border-gray-400"
      type="text"
      placeholder={placeholder}
      onChange={typeAction}
      {...props}
    />
  </div>
);

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  searchAction: PropTypes.func,
  typeAction: PropTypes.func
};

SearchBar.defaultProps = {
  placeholder: undefined,
  searchAction: () => {},
  typeAction: () => {}
};

export default SearchBar;
